import React from 'react';
import { useSelector } from 'react-redux';
import { Calendar, Globe, Location, Star } from '@yme/assets/icons/destinations';
import { LabelKeyPrefixes, LabelKeyTemplates } from '@yme/common/types';
import { OverviewComponent } from '@yme/components/Destinations/components';
import { useTranslation } from '@yme/services/i18n';
import { getExperienceDetailsPageState } from '../../../../redux/selectors';
export function Overview() {
    const { expLocation, expType, expLevel, expDuration, expDistance } = useSelector(getExperienceDetailsPageState);
    const expLabels = Array.isArray(expLevel) ? expLevel : [expLevel];
    const { t } = useTranslation();
    const durationAndDistanceText = expDuration || expDistance
        ? `${expDuration ? `${expDuration} ${t('common_days_label')}` : ''}
      ${expDuration && expDistance ? '/' : ''}
      ${expDistance ? `${expDistance} ${t('common_km_label')}` : ''}`
        : '';
    const overviewData = [
        {
            text: expLocation.join(', '),
            icon: Location,
        },
        {
            text: expType
                .map((l) => t(LabelKeyTemplates.TYPE.replace(LabelKeyPrefixes.TYPE, l)))
                .join(', '),
            icon: Globe,
        },
        {
            text: expLabels
                .map((l) => t(LabelKeyTemplates.LEVEL.replace(LabelKeyPrefixes.LEVEL, l)))
                .join(', '),
            icon: Star,
        },
        {
            text: durationAndDistanceText,
            icon: Calendar,
        },
    ];
    return (React.createElement(OverviewComponent, { config: overviewData, title: `${t('destinations_experienceOverview_label')}:` }));
}
